import { render, staticRenderFns } from "./index.vue?vue&type=template&id=276b0b6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=276b0b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b0b6a",
  null
  
)

export default component.exports